import React from 'react'
import StaycationLayout from './StaycationLayout'
import { StaycationForm } from 'components/Staycation/book-btn'
import contactImg from '../../assets/images/contactImg.png'
const StaycationContact = () => {
  return (
    <StaycationLayout title="CONTACT US">
      <div className="z-50  bg-white">
        <div className="mb-3 contact-main">
          <div className="text-center w-90 mx-auto py-3">
            <h2 className="py-2">
              Connect with <span className="text-primary">Us</span> for All Your
              <span className="text-primary"> Real Estate Needs</span>
            </h2>
            <p className="fs-18">
              Welcome to our Contact page, where you can reach out to our team
              of experienced professionals for personalized support and
              assistance. Whether you have questions about buying or selling
              property, or just want to learn more about the real estate market,
              we're here to help.
            </p>
          </div>
          <div className="my-4 fs-16 py-2">
            <h5 >Use our directory</h5>
            <p className="py-3">
              Find the best contact information for your specific needs. Our
              goal is to make your real estate journey as seamless and
              stress-free as possible, so don't hesitate to reach out to us
              today.
            </p>
            <div className="row g-4 my-3">
              <div className="col-12 col-md-4">
                <div
                  className="border-green rounded-2 text-center p-3 w-full"
                  style={{ height: '100%' }}
                >
                  <svg
                    width="65"
                    height="64"
                    viewBox="0 0 65 64"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="0.498535"
                      width="64"
                      height="64"
                      rx="32"
                      fill="#47BBA9"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M22.7267 14.7085C23.0019 14.9246 23.311 15.2154 23.6665 15.5666C24.4283 16.3163 25.312 17.5175 26.0703 18.6706C26.8371 19.8366 27.5477 21.0641 27.9459 21.9185L27.9462 21.9191L27.9464 21.9196C28.1722 22.4051 28.3756 22.845 28.5187 23.2305C28.6639 23.622 28.7846 24.0527 28.7854 24.5227C28.787 25.5064 28.253 26.2657 27.7387 26.966C27.5909 27.1672 27.4654 27.332 27.3572 27.4741C27.1239 27.7804 26.971 27.9812 26.8486 28.2134C26.7292 28.4399 26.6944 28.6034 26.7509 28.8667C26.8324 29.2463 27.1867 30.0773 27.8746 31.1643C28.5399 32.2156 29.4509 33.4014 30.5393 34.4864C31.6274 35.5711 32.7943 36.458 33.8247 37.0997C34.8864 37.761 35.704 38.1005 36.0945 38.1838C36.3663 38.2418 36.5361 38.2055 36.763 38.0874C37.0024 37.9627 37.2155 37.8001 37.5467 37.5472C37.6769 37.4479 37.8253 37.3345 38.0007 37.2041L38.001 37.2039L38.0143 37.1941C38.717 36.672 39.4977 36.0919 40.4873 36.093C40.9762 36.0935 41.4151 36.2316 41.8015 36.3893C42.1706 36.54 42.5948 36.7536 43.06 36.988L43.0989 37.0076C43.9144 37.4188 45.1268 38.1154 46.3006 38.8748C47.4536 39.6207 48.6702 40.4915 49.4278 41.2548L49.4289 41.2559C49.7811 41.6116 50.0726 41.9207 50.2892 42.1957C50.4989 42.462 50.7291 42.8064 50.8262 43.2349C50.9355 43.7175 50.8364 44.119 50.7348 44.3975C50.689 44.523 50.6349 44.6435 50.5961 44.7298C50.5901 44.7432 50.5842 44.7563 50.5784 44.7692C50.5423 44.8491 50.5109 44.9189 50.4775 44.9988L50.4767 45.0007L50.4759 45.0027C50.133 45.8157 49.716 46.5954 49.23 47.3319L49.2285 47.3341L49.2271 47.3363C48.2775 48.7629 47.3842 49.695 45.9956 50.3418C45.274 50.6779 44.243 51.0173 42.6408 50.8175C41.0996 50.6254 39.0946 49.943 36.3582 48.4105L36.3575 48.4101C31.9786 45.9542 28.9402 43.837 25.0207 39.9284C21.1127 36.0314 19.1919 33.4879 16.5011 28.5996C13.7922 23.6785 13.796 20.6438 14.5696 18.9907C15.2192 17.6027 16.1606 16.7135 17.5824 15.7689L17.5852 15.767L17.5881 15.7652C18.3254 15.2808 19.1055 14.8649 19.9186 14.5228L19.9213 14.5216L19.924 14.5205C20.0045 14.4871 20.0748 14.4555 20.1553 14.4194C20.1679 14.4138 20.1808 14.408 20.194 14.4021C20.2805 14.3634 20.4011 14.3096 20.5265 14.264C20.8046 14.163 21.2053 14.0643 21.6871 14.173C22.1154 14.2695 22.4599 14.499 22.7267 14.7085ZM20.9342 16.9434C20.2707 17.2227 19.634 17.5621 19.0322 17.9572C17.8311 18.7555 17.3162 19.3148 16.9472 20.1033C16.7019 20.6273 16.2481 22.6966 18.8007 27.3337C21.3713 32.0037 23.1419 34.3477 26.8743 38.0697C30.595 41.78 33.4315 43.7594 37.6409 46.1202C40.2168 47.5629 41.8868 48.0782 42.9656 48.2127C43.9832 48.3396 44.5169 48.1348 44.8872 47.9623C45.6819 47.5921 46.2436 47.0808 47.0406 45.8838C47.4367 45.283 47.7768 44.6472 48.0565 43.9842C48.0942 43.894 48.1312 43.8106 48.1625 43.7409C48.0401 43.5957 47.8526 43.3948 47.5642 43.1035C47.019 42.5543 46.0071 41.8114 44.8747 41.0787C43.7629 40.3594 42.6328 39.7125 41.9175 39.3517C41.4012 39.0917 41.0705 38.9262 40.8094 38.8196C40.5554 38.7159 40.4816 38.718 40.4845 38.718C40.5083 38.718 40.4271 38.6716 39.5665 39.311C39.4785 39.3764 39.3835 39.4493 39.2829 39.5264C38.8994 39.8204 38.4351 40.1763 37.975 40.4158C37.2875 40.7737 36.4983 40.954 35.547 40.7511C34.7145 40.5735 33.5916 40.0471 32.4369 39.3279C31.2507 38.589 29.9251 37.5806 28.6861 36.3455C27.4472 35.1106 26.4165 33.769 25.6565 32.5681C24.9192 31.403 24.3645 30.257 24.1844 29.4177C23.9792 28.4619 24.1662 27.6727 24.5265 26.9893C24.7587 26.5489 25.1057 26.0938 25.3914 25.7193C25.4754 25.6091 25.5541 25.5059 25.6231 25.4121C26.1748 24.6608 26.1619 24.541 26.1605 24.528C26.1604 24.5276 26.1604 24.5272 26.1604 24.527C26.1603 24.5017 26.1545 24.4048 26.0575 24.1434C25.9584 23.8761 25.804 23.5378 25.5663 23.0267C25.2418 22.3307 24.6056 21.2207 23.8771 20.1129C23.1401 18.9922 22.38 17.9832 21.8245 17.4368L21.8236 17.4359L21.8227 17.4349C21.5296 17.1454 21.328 16.9578 21.1825 16.8357C21.1118 16.8673 21.0266 16.9049 20.9342 16.9434Z"
                      fill="white"
                    />
                  </svg>

                  <h6 className="mt-2">Let's talk on the phone</h6>
                  <p className="my-2">
                    Give us a call at&nbsp;
                    <span>
                      <a href="tel:+2349118008008" className="text-primary">
                        +2349118008008
                      </a>
                    </span>
                    &nbsp; or&nbsp;
                    <span>
                      <a href="tel:+2349118008008" className="text-primary">
                        +2349118008008
                      </a>
                    </span>
                    &nbsp;to talk to us directly
                  </p>
                </div>
              </div>
              <div className="col-12 col-md-4">
                <div
                  className="border-green rounded-2 text-center p-3 w-full"
                  style={{ height: '100%' }}
                >
                  <svg
                    width="81"
                    height="80"
                    viewBox="0 0 81 80"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="0.5"
                      width="80"
                      height="80"
                      rx="40"
                      fill="#47BBA9"
                      fillOpacity="0.36"
                    />
                    <rect
                      x="8.49854"
                      y="8"
                      width="64"
                      height="64"
                      rx="32"
                      fill="#47BBA9"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M26.7192 29.1873C25.6319 29.1873 24.7505 30.0687 24.7505 31.156V50.8435C24.7505 51.9308 25.6319 52.8122 26.7192 52.8122H54.2817C55.369 52.8122 56.2505 51.9308 56.2505 50.8435V31.156C56.2505 30.0687 55.369 29.1873 54.2817 29.1873H26.7192ZM22.1255 31.156C22.1255 28.6189 24.1822 26.5623 26.7192 26.5623H54.2817C56.8188 26.5623 58.8755 28.6189 58.8755 31.156V50.8435C58.8755 53.3805 56.8188 55.4372 54.2817 55.4372H26.7192C24.1822 55.4372 22.1255 53.3805 22.1255 50.8435V31.156Z"
                      fill="white"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M27.652 32.319C28.0971 31.7468 28.9217 31.6438 29.4938 32.0888L40.5005 40.6496L51.5072 32.0888C52.0794 31.6438 52.904 31.7468 53.3491 32.319C53.7941 32.8912 53.691 33.7158 53.1188 34.1608L41.3063 43.3483C40.8324 43.717 40.1687 43.717 39.6947 43.3483L27.8823 34.1608C27.3101 33.7158 27.207 32.8912 27.652 32.319Z"
                      fill="white"
                    />
                  </svg>

                  <h6 className="mt-2">Send us an email</h6>
                  <p className="my-2">
                    you can shoot us an email at <br />{' '}
                    <span>
                      <a
                        href="mailto:hello@krent.space"
                        className="text-primary"
                      >
                        hello@krent.space
                      </a>
                    </span>
                    &nbsp;or&nbsp;
                    <span>
                      <a
                        href="mailto:info@krent.space"
                        className="text-primary"
                      >
                        info@krent.space
                      </a>
                    </span>
                  </p>
                </div>
              </div>
              <div className="col-12 col-md-4">
                <div
                  className="border-green rounded-2 text-center p-3 w-full"
                  style={{ height: '100%' }}
                >
                  <svg
                    width="65"
                    height="64"
                    viewBox="0 0 65 64"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="0.498047"
                      width="64"
                      height="64"
                      rx="32"
                      fill="#47BBA9"
                    />
                    <path
                      d="M22 48.6872C21.2751 48.6872 20.6875 49.2749 20.6875 49.9997C20.6875 50.7246 21.2751 51.3122 22 51.3122V48.6872ZM43 51.3122C43.7249 51.3122 44.3125 50.7246 44.3125 49.9997C44.3125 49.2749 43.7249 48.6872 43 48.6872V51.3122ZM44.3125 28.1247C44.3125 31.1111 42.4047 34.9735 39.7707 38.1817C38.4758 39.7589 37.0626 41.106 35.7313 42.0467C34.3592 43.0163 33.2397 43.4372 32.5 43.4372V46.0622C34.0572 46.0622 35.7267 45.2642 37.2462 44.1905C38.8066 43.0879 40.3874 41.5674 41.7995 39.8474C44.5796 36.4613 46.9375 32.0113 46.9375 28.1247H44.3125ZM32.5 43.4372C31.7868 43.4372 30.6791 42.9986 29.2992 41.9626C27.9657 40.9615 26.5488 39.531 25.2494 37.8666C22.6068 34.4819 20.6875 30.4435 20.6875 27.4442H18.0625C18.0625 31.3178 20.4088 35.9321 23.1803 39.482C24.5879 41.2849 26.1651 42.8921 27.7232 44.0619C29.235 45.1968 30.9163 46.0622 32.5 46.0622V43.4372ZM20.6875 27.4442C20.6875 21.0908 26.3375 16.3123 32.5 16.3123V13.6873C25.1315 13.6873 18.0625 19.4087 18.0625 27.4442H20.6875ZM32.5 16.3123C38.6142 16.3123 44.3125 21.0461 44.3125 28.1247H46.9375C46.9375 19.4534 39.9168 13.6873 32.5 13.6873V16.3123ZM36.4375 27.2497C36.4375 29.4244 34.6746 31.1872 32.5 31.1872V33.8122C36.1244 33.8122 39.0625 30.8741 39.0625 27.2497H36.4375ZM32.5 31.1872C30.3254 31.1872 28.5625 29.4244 28.5625 27.2497H25.9375C25.9375 30.8741 28.8756 33.8122 32.5 33.8122V31.1872ZM28.5625 27.2497C28.5625 25.0751 30.3254 23.3123 32.5 23.3123V20.6873C28.8756 20.6873 25.9375 23.6254 25.9375 27.2497H28.5625ZM32.5 23.3123C34.6746 23.3123 36.4375 25.0751 36.4375 27.2497H39.0625C39.0625 23.6254 36.1244 20.6873 32.5 20.6873V23.3123ZM22 51.3122H43V48.6872H22V51.3122Z"
                      fill="white"
                    />
                  </svg>

                  <h6 className="mt-2">Visit us at our location</h6>
                  <p className="my-2">
                    Visit our headquarters, <br />{' '}
                    <span className="text-primary">
                      H3 Bayview estate ikate Lekki Lagos
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="relative bg-cover w-full h-screen flex  py-4"
        style={{
          backgroundImage: `url(${contactImg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="contact-container rounded-2">
          <div>
            <StaycationForm contactHeading />
          </div>
        </div>
      </div>
    </StaycationLayout>
  )
}

export default StaycationContact
